import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { RuleName } from '../types';

import { TimestampRule } from './TimestampRule';

interface Props {
  ruleVariableName: RuleName;
}

export const ControlledTimestampRule: React.FC<Props> = ({
  ruleVariableName
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={`rules.${ruleVariableName}.value`}
      render={({ field, fieldState }) => (
        <TimestampRule
          onChange={field.onChange}
          error={Boolean(fieldState.error)}
          helperText={fieldState?.error?.message}
          ruleVariableName={ruleVariableName}
          value={field.value}
        />
      )}
    />
  );
};
